exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.i(require("-!../../node_modules/css-loader/index.js!onsenui/css/onsenui.css"), "");
exports.i(require("-!../../node_modules/css-loader/index.js!onsenui/css-components-src/src/onsen-css-components.css"), "");

// module
exports.push([module.id, "body{text-transform:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/styles/index.scss
// module id = 296
// module chunks = 1